// Based off playground/src/ui-components/Icon.tsx
import React from 'react'

import Flex, { FlexProps } from './Flex'
import styled from 'styled-components'
import { color, space } from 'styled-system'

export const iconLookup: Record<string, React.ElementType> = {
  add: require('./icons/Add').default,
  addCircle: require('./icons/AddCircle').default,
  AddCircleGreyable: require('./icons/AddCircleGreyable').default,
  alert: require('./icons/Alert').default,
  alignCenter: require('./icons/AlignCenter').default,
  alignLeft: require('./icons/AlignLeft').default,
  alignRight: require('./icons/AlignRight').default,
  arrowRight: require('./icons/ArrowRight').default,
  bold: require('./icons/Bold').default,
  bookmark: require('./icons/Bookmark').default,
  bookmarkActive: require('./icons/BookmarkActive').default,
  bullet: require('./icons/Bullet').default,
  calendar: require('./icons/Calendar').default,
  canvasNav: require('./icons/CanvasNav').default,
  check: require('./icons/Check').default,
  checkCircle: require('./icons/CheckCircle').default,
  checkCircleAlt: require('./icons/CheckCircleAlt').default,
  chevronDown: require('./icons/ChevronDown').default,
  chevronLeft: require('./icons/ChevronLeft').default,
  chevronLeftDouble: require('./icons/ChevronLeftDouble').default,
  chevronRight: require('./icons/ChevronRight').default,
  chevronRightDouble: require('./icons/ChevronRightDouble').default,
  chevronUp: require('./icons/ChevronUp').default,
  chevronUpTransparent: require('./icons/ChevronUpTransparent').default,
  children: require('./icons/Children').default,
  childrenNav: require('./icons/ChildrenNav').default,
  clipboard: require('./icons/Clipboard').default,
  clone: require('./icons/Clone').default,
  close: require('./icons/Close').default,
  cog: require('./icons/Cog').default,
  cohortTrackingNav: require('./icons/CohortTrackingNav').default,
  collage: require('./icons/Collage').default,
  color: require('./icons/Color').default,
  comments: require('./icons/Comments').default,
  commentsAlt: require('./icons/CommentsAlt').default,
  commsCenter: require('./icons/CommsCenter').default,
  content: require('./icons/Content').default,
  copy: require('./icons/Copy').default,
  dashboardNav: require('./icons/DashboardNav').default,
  delete: require('./icons/Delete').default,
  draft: require('./icons/Draft').default,
  edit: require('./icons/Edit').default,
  editOutlined: require('./icons/EditOutlined').default,
  educatorsNav: require('./icons/EducatorsNav').default,
  error: require('./icons/Error').default,
  evacuationReport: require('./icons/notifications/playground/EvacuationReport').default,
  feedback: require('./icons/Feedback').default,
  file: require('./icons/File').default,
  fileDownload: require('./icons/FileDownload').default,
  financeNav: require('./icons/FinanceNav').default,
  folder: require('./icons/Folder').default,
  fullscreen: require('./icons/Fullscreen').default,
  hand: require('./icons/Hand').default,
  happy: require('./icons/Happy').default,
  headCountTick: require('./icons/notifications/playground/HeadCountTick').default,
  help: require('./icons/Help').default,
  hightlightOff: require('./icons/HighlightOff').default,
  image: require('./icons/Image').default,
  imagePlaceholder: require('./icons/ImagePlaceholder').default,
  incidentReport: require('./icons/notifications/playground/IncidentReport').default,
  italic: require('./icons/Italic').default,
  learningContent: require('./icons/LearningContent').default,
  learningContentArticle: require('./icons/LearningContentArticle').default,
  learningContentVideo: require('./icons/LearningContentVideo').default,
  learningContentPodcast: require('./icons/LearningContentPodcast').default,
  learningFramework: require('./icons/LearningFramework').default,
  learningFrameworksNav: require('./icons/LearningFrameworksNav').default,
  learningOutcome: require('./icons/LearningOutcome').default,
  medicalReport: require('./icons/notifications/playground/MedicalReport').default,
  momentCreated: require('./icons/notifications/playground/MomentCreated').default,
  moments: require('./icons/Moments').default,
  momentsNav: require('./icons/MomentsNav').default,
  multiplePeopleAdd: require('./icons/MultiplePeopleAdd').default,
  multiplePeopleRemove: require('./icons/MultiplePeopleRemove').default,
  multiplePeopleTime: require('./icons/MultiplePeopleTime').default,
  notification: require('./icons/Notification').default,
  noPhotos: require('./icons/NoPhotos').default,
  numbered: require('./icons/Numbered').default,
  observationApproved: require('./icons/notifications/playground/ObservationApproved').default,
  observationGeneral: require('./icons/notifications/playground/ObservationGeneral').default,
  observationModified: require('./icons/notifications/playground/ObservationModified').default,
  observationRemoved: require('./icons/notifications/playground/ObservationRemoved').default,
  observations: require('./icons/Observations').default,
  observationsNav: require('./icons/ObservationsNav').default,
  open: require('./icons/Open').default,
  outcome: require('./icons/Outcome').default,
  outcomes: require('./icons/Outcomes').default,
  overflow: require('./icons/Overflow').default,
  paperclip: require('./icons/Paperclip').default,
  pin: require('./icons/Pin').default,
  plans: require('./icons/Plans').default,
  play: require('./icons/Play').default,
  printer: require('./icons/Printer').default,
  redo: require('./icons/Redo').default,
  reportsNav: require('./icons/ReportsNav').default,
  reflections: require('./icons/Reflections').default,
  removeCircle: require('./icons/RemoveCircle').default,
  rocket: require('./icons/Rocket').default,
  roomsNav: require('./icons/RoomsNav').default,
  save: require('./icons/Save').default,
  search: require('./icons/Search').default,
  service: require('./icons/Service').default,
  shapes: require('./icons/Shapes').default,
  stickers: require('./icons/Stickers').default,
  stop: require('./icons/Stop').default,
  stories: require('./icons/StoriesNav').default,
  tables: require('./icons/Tables').default,
  tablesNav: require('./icons/TablesNav').default,
  text: require('./icons/Text').default,
  triangleDown: require('./icons/TriangleDown').default,
  triangleUp: require('./icons/TriangleUp').default,
  undo: require('./icons/Undo').default,
  user: require('./icons/User').default,
  wheelchair: require('./icons/Wheelchair').default,
  video: require('./icons/Video').default,
  zoomIn: require('./icons/ZoomIn').default,
  zoomOut: require('./icons/ZoomOut').default,
}

const fill = (props: any) =>
  props.fill
    ? {
        fill: props.theme.colors[props.fill] ? props.theme.colors[props.fill] : props.fill,
      }
    : null

const stroke = (props: any) =>
  props.stroke
    ? {
        stroke: props.theme.colors[props.stroke] ? props.theme.colors[props.stroke] : props.stroke,
      }
    : null

interface Props extends FlexProps {
  disabled?: boolean
  cursorPointer?: boolean
  name: keyof typeof iconLookup
  size?: number
}

const Base = ({ name, size = 24, ...props }: Props) => {
  const IconComponent = iconLookup[name]

  if (!IconComponent) {
    console.warn(`No icon found: ${name}`)
    return null
  }

  return (
    <Flex {...props} alignItems="center" width={size}>
      <IconComponent />
    </Flex>
  )
}

const Icon = styled(Base)`
  ${({ cursorPointer }) => !(cursorPointer === false) && { cursor: 'pointer' }};
  flex: none;
  pointer-events: auto;

  ${space};
  ${color};
  ${fill};
  ${stroke};

  ${({ disabled }) => disabled && { fill: 'rgb(0, 0, 0, 0.35)' }};
  transition: fill 0.25s ease;

  svg {
    height: auto;
    width: 100%;
  }
`

Icon.displayName = 'Icon'

export default React.memo(Icon)
